import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
// internal
import { getStyles as getDfltStyles } from './styles.css';
import block from './block.json';

/**
 * COMPONENT
 */
export const ListCards: FC<ListCardsProps> & BlockConfigs = ({
	slug,
	title,
	children,
	theme = {},
	getStyles = getDfltStyles,
}) => {
	const { variant, blockTheme } = useThemeBlock(slug, theme);

	const trimmedSlug = slug.split('/');
	const modifierSlug = trimmedSlug[trimmedSlug.length - 1];

	const rootClass = cx(
		'supt-listCards',
		`supt-listCards--${modifierSlug}`,
		getStyles(blockTheme)
	);

	return (
		<div className={rootClass} data-block={slug} data-variant={variant}>
			{title ? (
				<h3
					className="supt-listCards__title"
					dangerouslySetInnerHTML={{ __html: title }}
				/>
			) : null}
			<div className="supt-listCards__list">{children}</div>
		</div>
	);
};

ListCards.slug = block.slug;
ListCards.title = block.title;
